import { useState } from "react";
import { useContract } from "./useContract";
import { AdditionalIProps } from "../model/schema";

interface MutateOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useAddAdditional = () => {
  const { addAdditional } = useContract();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const mutate = async (data: AdditionalIProps, options?: MutateOptions) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const result = await addAdditional(data);
      if (result.data) {
        setData(result.data);
        options?.onSuccess?.(result.data);
      } else {
        setError("Не удалось сохранить доп. соглашение");
        options?.onError?.("Не удалось сохранить доп. соглашение");
      }
    } catch (error) {
      setError("Не удалось сохранить доп. соглашение");
      options?.onError?.("Не удалось сохранить доп. соглашение");
    } finally {
      setIsLoading(false);
    }
  };

  return { mutate, isLoading, error, isSuccess, data };
};
